var SizeEnum = /*#__PURE__*/function (SizeEnum) {
  SizeEnum["xs-3"] = "xs-3";
  SizeEnum["xs-2"] = "xs-2";
  SizeEnum["xxs"] = "xxs";
  SizeEnum["xs"] = "xs";
  SizeEnum["sm"] = "sm";
  SizeEnum["md"] = "md";
  SizeEnum["lg"] = "lg";
  SizeEnum["xl"] = "xl";
  SizeEnum["xxl"] = "xxl";
  SizeEnum["xl+2"] = "xl+2";
  SizeEnum["xl+3"] = "xl+3";
  SizeEnum["xl+4"] = "xl+4";
  SizeEnum["xl+5"] = "xl+5";
  SizeEnum["xl+6"] = "xl+6";
  return SizeEnum;
}({});

export { SizeEnum };
//# sourceMappingURL=size-enum.esm.js.map
